module.exports = __webpack_public_path__ + "img/web-p2-f4.95053acd.svg";